import { render, staticRenderFns } from "./GridProperties.vue?vue&type=template&id=0d41bcd8"
import script from "./GridProperties.vue?vue&type=script&lang=js"
export * from "./GridProperties.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports